import { render, staticRenderFns } from "./pd-pace-feature-comparison.vue?vue&type=template&id=5ca357bd&"
import script from "./pd-pace-feature-comparison.vue?vue&type=script&lang=js&"
export * from "./pd-pace-feature-comparison.vue?vue&type=script&lang=js&"
import style0 from "./pd-pace-feature-comparison.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductName: require('/opt/build/repo/storefront/components/legacy/global/product-name.vue').default,SgLink: require('/opt/build/repo/storefront/components/legacy/global/sg-link.vue').default})
